function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.6303 2.25592L14.041 2.84518C13.7156 3.17061 13.7156 3.69825 14.041 4.02369L16.0975 6.08019C16.423 6.40563 16.9506 6.40563 17.2761 6.08019L17.8653 5.49093C18.1907 5.1655 18.1907 4.63786 17.8653 4.31242L15.8088 2.25592C15.4834 1.93048 14.9557 1.93048 14.6303 2.25592ZM11.684 5.2022L3.28905 13.5972C3.13315 13.7531 3.04539 13.9644 3.04498 14.1849L3.04113 16.2473C3.04026 16.7087 3.41456 17.083 3.87601 17.0822L5.93841 17.0783C6.15888 17.0779 6.37021 16.9901 6.52611 16.8342L14.9211 8.43926C15.2465 8.11382 15.2465 7.58618 14.9211 7.26074L12.8625 5.2022C12.5371 4.87676 12.0095 4.87676 11.684 5.2022Z",
  fill: "#0067E2"
});

var SvgIcEditPencil = function SvgIcEditPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcEditPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-edit-pencil.6bae3715.svg";
export { ForwardRef as ReactComponent };